import { throttle } from 'lodash';
import { snapshot } from 'valtio';
import { createSimpleAsyncAction } from 'async-utils';
import sbomService from '../services';
import SbomStore from '../stores/sbom-store';
import SbomFiltersStore from '../stores/sbom-filters-store';
import {
  setStoreLibrariesFilters,
  setStoreLibrariesFiltersTypeSearch,
} from '../stores/sbom-filters-store-actions';
import { loadSbomLibraries } from './sbom-libraries-actions';
import { navigateToSbom } from '../../common/routing/app-navigator';

export const loadFilters = createSimpleAsyncAction(
  async (cache: boolean = true, limit: number = 100, offset?: number) => {
    const results = await sbomService.getSbomLibrariesFilters.execute(
      {
        search: SbomStore.searchValue,
        limit: limit,
        offset: SbomStore.offset,
        filters: SbomFiltersStore.filterBy,
      },
      cache,
    );

    if (results) {
      setStoreLibrariesFilters(results);
      setStoreLibrariesFiltersTypeSearch(results);
    }
  },
  {
    asyncState: SbomFiltersStore.loadingFilters,
    errorMessage: 'Failed to load libraries filters',
  },
);

export const onChangeFilter = throttle(
  (e: React.ChangeEvent<HTMLInputElement>) => {
    const { loadingFilters } = snapshot(SbomFiltersStore);
    const { loading } = snapshot(SbomStore);
    if (loadingFilters.isPending() || loading.isPending()) {
      return;
    }

    if (SbomFiltersStore.filterBy[e.target.id]) {
      const index = SbomFiltersStore.filterBy[e.target.id].indexOf(
        e.target.value,
      );
      if (index !== -1) {
        SbomFiltersStore.filterBy[e.target.id].splice(index, 1);
      } else {
        SbomFiltersStore.filterBy[e.target.id].push(e.target.value);
      }
    } else {
      SbomFiltersStore.filterBy[e.target.id] = [e.target.value];
    }
    navigateToSbom(SbomFiltersStore.filterBy);
    loadSbomLibraries({ update: true });
    loadFilters();
  },
  1000,
);

export const setInitialFilters = (encodedFilters: string | null) => {
  if (!encodedFilters) return;
  let filters = {};
  try {
    filters = JSON.parse(decodeURI(encodedFilters));
  } catch {}
  SbomFiltersStore.filterBy = filters;
};
